export default __webpack_public_path__ + "static/media/Rustic-Wall-Cream-Terracotta-Brown.5314f3d0.jpg";